/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { Schema } from '@jalik/schema'

const RoleSchema = new Schema({
  name: {
    type: 'string',
    maxLength: 50,
    required: true
  },
  permissions: {
    type: 'array',
    items: {
      type: 'integer'
    }
  },
  slug: {
    type: 'string',
    maxLength: 50,
    required: true
  }
})

export default RoleSchema
